"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import CarrierService from "../services/carrier_service";
import Account from "../api/account";
import { Tooltip, TooltipDirection, TooltipLocation } from "./ui/v3/tooltip";
import Auth from "../util/auth";
function carrierName(props, state) {
  let name = state.carrier.name;
  if (shouldIncludeExternalVendorId(props, state)) {
    name += " - ";
    name += state.carrier.external_vendor_id;
  }
  if (props.displayNoBuy && state.carrier.data && state.carrier.data["no_buy"]) {
    return /* @__PURE__ */ jsxs(
      "span",
      {
        "data-tooltip": true,
        "aria-haspopup": "true",
        title: "Client marked Do Not Allow Purchases",
        children: [
          /* @__PURE__ */ jsx("i", { className: "fi-alert alert" }),
          " ",
          name,
          " "
        ]
      }
    );
  }
  return name;
}
function shouldIncludeExternalVendorId(props, state) {
  return state.carrier.external_vendor_id && Auth._currentUser.account.factor_account && props.includeExternalVendorId;
}
function renderV3Reskin(props, state) {
  if (props.multiple) {
    const carrierNames = (props.carrierInvoices || []).map((carrierInvoice) => {
      const carrier = CarrierService.getCarrierOrUnknown(
        carrierInvoice.carrier_id
      );
      return carrier.name;
    });
    if (carrierNames.length < 3) {
      const content = carrierNames.map((carrierName2, i) => /* @__PURE__ */ jsxs("span", { children: [
        carrierName2,
        i == 0 ? ", " : ""
      ] }, carrierName2));
      return /* @__PURE__ */ jsxs("span", { children: [
        content,
        " ",
        props.trailingChip
      ] });
    } else {
      const tooltipContent = carrierNames.map((carrierName2) => {
        return /* @__PURE__ */ jsx(
          "div",
          {
            style: { whiteSpace: "nowrap" },
            children: `${carrierName2}`
          },
          carrierName2
        );
      });
      return /* @__PURE__ */ jsx(
        Tooltip,
        {
          content: /* @__PURE__ */ jsxs(
            "span",
            {
              style: {
                textDecoration: "underline",
                textDecorationStyle: "dotted"
              },
              children: [
                "Multiple ",
                props.trailingChip
              ]
            }
          ),
          tooltipContent,
          direction: TooltipDirection.Right,
          location: TooltipLocation.Hidden
        }
      );
    }
  } else {
    return /* @__PURE__ */ jsxs("span", { children: [
      state.carrier.name,
      " ",
      props.trailingChip
    ] });
  }
}
function possibleAccountExecName(props, state) {
  const id = state.carrier.id;
  if (props.displayAccountExec && id) {
    return /* @__PURE__ */ jsxs("div", { children: [
      /* @__PURE__ */ jsx("span", { children: "Account Exec:\xA0" }),
      /* @__PURE__ */ jsx("span", { children: accountExecName(state) })
    ] });
  }
}
function accountExecName(state) {
  var exec = state.carrier.account_exec;
  if (!exec) {
    exec = "Not set for " + Account.carrierTermLower();
  }
  return /* @__PURE__ */ jsx("span", { children: exec });
}
class CarrierName extends React.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "state", {
      carrier: { name: "Loading " + Account.carrierTerm() + " Name..." }
    });
    __publicField(this, "mounted", false);
    __publicField(this, "updateCarrier", (props) => {
      var component = this;
      component.setState({
        carrier: { name: "Loading " + Account.carrierTerm() + " Name..." }
      });
      CarrierService.carrierWithId(props.carrierID).then((carrier) => {
        if (component.mounted) {
          component.setState({ carrier });
        }
      }).catch(console.error);
    });
  }
  componentDidMount() {
    this.mounted = true;
  }
  componentWillUnmount() {
    this.mounted = false;
  }
  componentWillMount() {
    this.updateCarrier(this.props);
  }
  componentWillReceiveProps(newProps) {
    if (newProps.carrierID !== this.props.carrierID) {
      this.updateCarrier(newProps);
    }
  }
  render() {
    if (this.props.v3ReskinEnabled) {
      return renderV3Reskin(this.props, this.state);
    }
    if (this.props.multiple) {
      return /* @__PURE__ */ jsxs("span", { children: [
        "Multiple ",
        Account.carrierTerm(),
        "s"
      ] });
    }
    return /* @__PURE__ */ jsxs("span", { "data-component": "CarrierName", children: [
      /* @__PURE__ */ jsxs("span", { children: [
        this.props.carrierNamePrefix,
        carrierName(this.props, this.state),
        this.props.carrierNameSuffix
      ] }),
      possibleAccountExecName(this.props, this.state)
    ] });
  }
}
export default CarrierName;
